import { ReactNode } from 'react';
import classNames from 'classnames';
import noop from 'lodash/noop';

import styles from './progress-stop.module.scss';
import { resolveClassNames } from '../../../../../../helpers/classes';

export type ProgressStopProps = {
  iconContent: ReactNode;
  value: string;
  iconClassName?: string | Array<string>;
  valueClassName?: string | Array<string>;
  onContentAnimationComplete?: () => void;
  dataHookValue?: string;
};

export const ProgressStop = ({
  iconContent,
  value,
  iconClassName,
  valueClassName,
  onContentAnimationComplete = noop,
  dataHookValue = 'progress-stop',
}: ProgressStopProps) => (
  <div className={styles['progress-stop']}>
    <div className={styles['progress-stop__content']}>
      <div className={styles['progress-stop__icon-wrap']}>
        <div
          onTransitionEnd={evt => {
            evt.stopPropagation();
            onContentAnimationComplete();
          }}
          className={classNames(
            styles['progress-stop__icon'],
            resolveClassNames(iconClassName, styles),
          )}
        >
          {iconContent}
        </div>
      </div>
      <div
        data-hook={dataHookValue}
        onTransitionEnd={evt => {
          evt.stopPropagation();
        }}
        className={classNames(
          styles['progress-stop__value'],
          resolveClassNames(valueClassName, styles),
        )}
      >
        {value}
      </div>
    </div>
  </div>
);
